import React from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
} from "Components/Base/Inputs/ToggleButton";
import { ViewListIcon, ViewModuleIcon } from "Components/Icons";
import { useMyLearning } from "../context";

/**
 * ToggleButtonGroupViewType component for switching between list and card views
 *
 * @param {Object} props - Component props
 * @param {string} props.labels - Labels for accessibility
 * @returns {React.ReactElement} ToggleButtonGroup component for view type selection
 */
const ToggleButtonGroupViewType = ({ labels }) => {
  const { listView, setListView } = useMyLearning();

  /**
   * Handles the view type change
   *
   * @param {React.MouseEvent<HTMLElement>} event - The click event
   * @param {boolean} newView - The new view type value
   */
  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setListView(newView);
    }
  };

  return (
    <ToggleButtonGroup value={listView} exclusive onChange={handleViewChange}>
      <ToggleButton value={true} title={labels[0]} aria-label={labels[0]}>
        <ViewListIcon />
      </ToggleButton>
      <ToggleButton value={false} title={labels[1]} aria-label={labels[1]}>
        <ViewModuleIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ToggleButtonGroupViewType;
